import { Wrap } from '../../components/wap'

export const ContactDetail = () => {
  return (
    <Wrap>
      <div className='nr_banner'>
        <img
          alt=''
          className='text'
          src='https://static-download.globalcrown.com.cn/website/original/d/file/p/2023/02-10/3cade9d0b1f94dd04b9002770047a683.jpg'
        />
        <h2 className='wow fadeInUp animated'>联系我们</h2>
        <p className='small_title fb25 wow fadeInUp animated'>Contact Us</p>

        <div className='scroll_hint'>
          <div className='iconfont'>&#xe754;</div>
          <div className='tex'>向下滑动</div>
        </div>
        <span />
      </div>

      <div className='contact' id='contact'>
        <div className='contact_center vw80'>
          <div className='position-right'>
            <dt className='flex-container-row align-center'>
              <img
                alt='首页'
                src='https://static-download.globalcrown.com.cn/website/original/template/images/index.png'
              />{' '}
              <a href='/'>Home</a>&nbsp; &gt; &nbsp;<a href='/about/'>关于我们</a>&nbsp; &gt; &nbsp;
              <a href='/contact/'>联系我们</a>
            </dt>
          </div>

          <div className='map wow fadeInUp' data-wow-delay='0.1s'>
            <div id='dituContent' />
            <div className='companyname'>
              <h3>世冠科技 运营总部</h3>

              <div className='companyname_info mtop1'>
                <span>
                  <i className='iconfonttwo'>&#xe61f;</i>
                  <small className='f-14 f-bold'>
                    北京市海淀区东北旺西路8号院尚东数字谷A座3号楼二层
                  </small>
                </span>
                <span>
                  <i className='iconfonttwo'>&#xe966;</i>
                  <small className='f-14 f-bold'>4009960325</small>
                </span>
                <span>
                  <i className='iconfonttwo'>&#xe604;</i>
                  <small className='f-14 f-bold'>marketing@globalcrown.com.cn</small>
                </span>
              </div>
            </div>
          </div>

          <div className='contact_a'>
            <div className='btm-row scroll-animate father wow fadeInUp' data-wow-delay='0.2s'>
              <h3>西安子公司</h3>
              <span>
                <i className='iconfonttwo'>&#xe61f;</i>
                <small className='f-14 f-bold'>
                  陕西省西安市高新区丈八街办锦业一路52号宝德云谷国际B栋
                </small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe966;</i>
                <small className='f-14 f-bold'>4009960325</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe604;</i>
                <small className='f-14 f-bold'>marketing@globalcrown.com.cn</small>
              </span>
            </div>
            <div className='btm-row scroll-animate father wow fadeInUp' data-wow-delay='0.2s'>
              <h3>沈阳子公司</h3>
              <span>
                <i className='iconfonttwo'>&#xe61f;</i>
                <small className='f-14 f-bold'>
                  辽宁省沈阳市皇姑区黄河北大街56-34号中粮广场806室
                </small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe966;</i>
                <small className='f-14 f-bold'>4009960325</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe604;</i>
                <small className='f-14 f-bold'>marketing@globalcrown.com.cn</small>
              </span>
            </div>
            <div className='btm-row scroll-animate father wow fadeInUp' data-wow-delay='0.2s'>
              <h3>上海子公司</h3>
              <span>
                <i className='iconfonttwo'>&#xe61f;</i>
                <small className='f-14 f-bold'>上海市闵行区莘庄镇沪闵路6088号凯德商务楼二层</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe966;</i>
                <small className='f-14 f-bold'>4009960325</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe604;</i>
                <small className='f-14 f-bold'>marketing@globalcrown.com.cn</small>
              </span>
            </div>
            <div className='btm-row scroll-animate father wow fadeInUp' data-wow-delay='0.2s'>
              <h3>深圳子公司</h3>
              <span>
                <i className='iconfonttwo'>&#xe61f;</i>
                <small className='f-14 f-bold'>
                  深圳市龙岗区坂田街道象角塘社区坂澜大道107号深圳工业软件园1栋E座1001
                </small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe966;</i>
                <small className='f-14 f-bold'>4009960325</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe604;</i>
                <small className='f-14 f-bold'>marketing@globalcrown.com.cn</small>
              </span>
            </div>
            <div className='btm-row scroll-animate father wow fadeInUp' data-wow-delay='0.2s'>
              <h3>成都办事处</h3>
              <span>
                <i className='iconfonttwo'>&#xe966;</i>
                <small className='f-14 f-bold'>4009960325</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe604;</i>
                <small className='f-14 f-bold'>marketing@globalcrown.com.cn</small>
              </span>
            </div>
            <div className='btm-row scroll-animate father wow fadeInUp' data-wow-delay='0.2s'>
              <h3>武汉办事处</h3>
              <span>
                <i className='iconfonttwo'>&#xe966;</i>
                <small className='f-14 f-bold'>4009960325</small>
              </span>
              <span>
                <i className='iconfonttwo'>&#xe604;</i>
                <small className='f-14 f-bold'>china-wh@globalcrown.com.cn</small>
              </span>
            </div>
          </div>
        </div>
      </div>
    </Wrap>
  )
}
